<template lang="html">
  <v-container fluid class="fill-height">
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="pb-12 px-2 text-center">
          <img src="@/assets/images/svg/non_active.svg" alt="Non Active" class="img-non_active">
          <h4 class="headline my-5">
            {{ $t('there_is_problem') }} <br> :(
          </h4>
        </div>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="mt-3">
        <div class="powered-by text-center">
          <p class="mb-0">
            powered by
          </p>
          <div class="powered-by-olsera">
            <img src="@/assets/images/svg/olsera_logo.svg" alt="Olsera.com">
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
}
</script>
